
import { Options } from "vue-class-component";

import { Col, Row, List } from "vant";

import BaseList from "@/common/BaseList";

import UserVo from "@/vo/UserVo";

@Options({
  components: {
    [Col.name]: Col,
    [Row.name]: Row,
    [List.name]: List,
  },
})
/**托管超级会员的客户列表 */
export default class ShareholderMembers extends BaseList {
  reqUrl = "/zhShareholder/shareholder/getLowerMemberList";
  finished = true;
  _title = "客户列表";
  //    reqData={page:0,limit:10,orderId}
  mounted() {
    this.reqData.memberId = this.$route.query.code;
    this.$route.query.name
      ? (document.title = this.$route.query.name + "的客户")
      : "";
    this.finished = false;
    this.req_items();
    //    this.reqUrl=this.reqUrl+
  }
  protected init_item(val: any) {
    //  val.thumb = AppUtil.get_thumb(val.headImgurl);
    // //  身份：1用户，2会员，3超级会员，4老板（boss）
    let u = new UserVo();
    u.set_data(val);
    return u;
  }
  tel_click(tel: string) {
    window.location.href = "tel:" + tel;
  }
}
